import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;

import TAOS from "./../Taos";

const safeParser = (content) => {
  if (!content || typeof content !== 'string') return '';
  return Parser(content);
}

class Card extends Component {

  static defaultProps = {
    elm: null,
    className: '',
    image: '',
    phone: ''
  };

  render() {
    const { elm, className, image, phone } = this.props;
    if (!elm) return null;
    
    const cardClass = `${className} p-[20px] rounded-[15px] h-full tracking-[-0.04em] leading-none`;
    
    if(elm?.v == '1') return (
      <div className={`${cardClass}`}>
        <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[33px] w-full'>
          {elm?.icon != '' && (
            <img src={elm?.icon} width={24} height={24} />
          )}
          <div className='text-[#032432] text-[16px] xl:text-[18px]'>
            {safeParser(elm?.title)}
          </div>
        </div>
        <div className='mt-[10px] text-black/60 text-[14px] xl:text-[16px]'>
          {safeParser(elm?.text)}
        </div>
      </div>
    )
    if(elm?.v == '2') return (
      <div className={`${cardClass} bg-cover bg-center`} style={{ backgroundImage: `url(${elm?.image})` }}>
        {elm?.list.length == 1 ? (
          <div className='flex flex-col sm:flex-row items-start justify-between gap-[10px]'>
            <div>
              <div className='text-white text-[16px] xl:text-[18px]'>
                {safeParser(elm?.title)}
              </div>
              <div className='mt-[10px] text-white/60 text-[14px] xl:text-[16px]'>
                {safeParser(elm?.text)}
              </div>
              <div className='flex-none flex justify-between bg-white p-[15px] rounded-[15px] w-full h-auto mt-[28px] text-[12px] xl:text-[16px]'>
                <a href={`tel:${phone?.replace(/[-()\s]/g, '')}`} className='flex items-center gap-[7px]'>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10"/>
                    <path d="M13.875 6.75C13.875 6.3 13.5225 5.61 12.9975 5.0475C12.5175 4.53 11.88 4.125 11.25 4.125" stroke="#009EE3" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16.5 6.75C16.5 3.8475 14.1525 1.5 11.25 1.5" stroke="#009EE3" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <div>{phone}</div>
                </a>
                <a href="mailto:info@himavangard.ru" className='flex items-center gap-[7px]'>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.75 15.375H5.25C3 15.375 1.5 14.25 1.5 11.625V6.375C1.5 3.75 3 2.625 5.25 2.625H12.75C15 2.625 16.5 3.75 16.5 6.375V11.625C16.5 14.25 15 15.375 12.75 15.375Z" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.75 6.75L10.4025 8.625C9.63 9.24 8.3625 9.24 7.59 8.625L5.25 6.75" stroke="#009EE3" strokeWidth="1.125" strokeMiterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div>info@himavangard.ru</div>
                </a>
              </div>
            </div>
            <img src={image} width={247} height={157} className='h-auto flex-none rounded-[15px] w-full sm:w-[247px] object-cover' />
          </div>
        ) : (
          <div className='flex flex-col sm:flex-row items-start justify-between gap-[10px]'>
            <div className='flex-auto'>
              <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[33px] w-full'>
                {elm?.icon != '' && (
                  <img src={elm?.icon} width={24} height={24} />
                )}
                <div className='text-white text-[16px] xl:text-[18px]'>
                  {safeParser(elm?.title)}
                </div>
              </div>
              <div className='mt-[10px] text-white/60 text-[14px] xl:text-[16px]'>
                {safeParser(elm?.text)}
              </div>
            </div>
            <div className='flex-none bg-white p-[15px] rounded-[15px] h-auto w-full sm:w-[273px]'>
              <div className='flex items-center gap-[7px] text-[16px] xl:text-[18px] text-[#032432]'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8.00156 3H9.00156C7.05156 8.84 7.05156 15.16 9.00156 21H8.00156" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15 3C16.95 8.84 16.95 15.16 15 21" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3 16V15C8.84 16.95 15.16 16.95 21 15V16" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M3 8.99961C8.84 7.04961 15.16 7.04961 21 8.99961" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div>География поставок</div>
              </div>
              <ul className='text-[#032432] text-[14px] xl:text-[16px] list-disc pl-[25px]'>
                {(elm?.list || []).map((item, index) => (
                  <li key={index} className='mt-[10px]'>
                    {safeParser(item)}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    )
  }
}

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {

    }
  }

  static defaultProps = {
    
  };

  render() {
    const data = this.props?.data || {}
    const exportdata = data?.export || {
      cards: [],
      cards2: [],
      title: '',
      title_2: '',
      text: ''
    }

    const splitArray = (arr) => {
      const mid = Math.ceil(arr.length / 2);
      return [arr.slice(0, mid), arr.slice(mid)];
    }

    return (
      <div className='mt-[70px] xl:mt-[80px] max-w-full'>
        <div className='container'>
          <h2 className='font-medium text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{safeParser(exportdata?.title)}</h2>
          {exportdata?.cards && exportdata?.cards.length > 0 && (
            <>
              <div className='flex flex-col xl:flex-row gap-[10px] flex-wrap mt-[30px]'>
                <Card elm={exportdata?.cards[0]} className='bg-[#F5F7F9] w-full xl:w-auto flex-1 xl:min-h-[225px]' />
                <Card elm={exportdata?.cards[1]} className='bg-[#F5F7F9] flex-none w-full xl:w-[328px] xl:min-h-[225px]' />
                <Card elm={exportdata?.cards[2]} className='bg-[#F5F7F9] flex-none w-full xl:w-[360px] xl:min-h-[225px]' />
              </div>
              <div className='flex flex-col xl:flex-row gap-[10px] flex-wrap mt-[10px]'>
                <Card elm={exportdata?.cards[3]} image={exportdata?.image} phone={data?.phone} className='bg-[#032432] w-full xl:w-auto flex-1 xl:min-h-[225px]' />
                <Card elm={exportdata?.cards[4]} className='bg-[#F5F7F9] flex-none w-full xl:w-[252px] xl:min-h-[225px]' />
                <Card elm={exportdata?.cards[5]} className='bg-[#F5F7F9] flex-none w-full xl:w-[277px] xl:min-h-[225px]' />
              </div>
            </>
          )}
          <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px] mt-[60px] xl:mt-[80px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z" stroke="#032432" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M1.5 9.66007V8.34007C1.5 7.56007 2.1375 6.91507 2.925 6.91507C4.2825 6.91507 4.8375 5.95507 4.155 4.77757C3.765 4.10257 3.9975 3.22507 4.68 2.83507L5.9775 2.09257C6.57 1.74007 7.335 1.95007 7.6875 2.54257L7.77 2.68507C8.445 3.86257 9.555 3.86257 10.2375 2.68507L10.32 2.54257C10.6725 1.95007 11.4375 1.74007 12.03 2.09257L13.3275 2.83507C14.01 3.22507 14.2425 4.10257 13.8525 4.77757C13.17 5.95507 13.725 6.91507 15.0825 6.91507C15.8625 6.91507 16.5075 7.55257 16.5075 8.34007V9.66007C16.5075 10.4401 15.87 11.0851 15.0825 11.0851C13.725 11.0851 13.17 12.0451 13.8525 13.2226C14.2425 13.9051 14.01 14.7751 13.3275 15.1651L12.03 15.9076C11.4375 16.2601 10.6725 16.0501 10.32 15.4576L10.2375 15.3151C9.5625 14.1376 8.4525 14.1376 7.77 15.3151L7.6875 15.4576C7.335 16.0501 6.57 16.2601 5.9775 15.9076L4.68 15.1651C3.9975 14.7751 3.765 13.8976 4.155 13.2226C4.8375 12.0451 4.2825 11.0851 2.925 11.0851C2.1375 11.0851 1.5 10.4401 1.5 9.66007Z" stroke="#032432" strokeWidth="1.125" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Как мы работаем</div>
            </div>
          </div>
          <h2 className='font-medium text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none mt-[30px]'>{safeParser(exportdata?.title_2)}</h2>
          <div className='mt-[10px] text-black/60 text-[14px] xl:text-[16px] text-center xl:text-start tracking-[-0.02em]'>{safeParser(exportdata?.text)}</div>
          {exportdata?.cards2 && exportdata?.cards2.length > 0 && (
            <>
              <div className='flex flex-col xl:flex-row gap-[10px] flex-wrap mt-[30px]'>
                <Card elm={exportdata?.cards2[0]} className='bg-[#F5F7F9] flex-none w-full xl:w-[400px] xl:min-h-[173px]' />
                <Card elm={exportdata?.cards2[1]} className='bg-[#F5F7F9] flex-1 w-full xl:w-auto xl:min-h-[173px]' />
                <Card elm={exportdata?.cards2[2]} className='bg-[#F5F7F9] flex-none w-full xl:w-[400px] xl:min-h-[173px]' />
              </div>
              <div className='flex flex-col xl:flex-row gap-[10px] flex-wrap mt-[10px]'>
                <Card elm={exportdata?.cards2[3]} className='bg-[#F5F7F9] flex-none w-full xl:w-[229px] xl:min-h-[225px]' />
                <Card elm={exportdata?.cards2[4]} className='bg-[#F5F7F9] flex-none w-full xl:w-[248px] xl:min-h-[225px]' />
                <Card elm={exportdata?.cards2[5]} className='bg-[#032432] flex-1 w-full xl:w-auto xl:min-h-[225px]' />
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default App;